/**
 * Auth diagnostics beacon (Sam, Oct 10): tells the server when a signed-in
 * user ends up signed out. Sends ids/status only — never token contents.
 */
import { readBrowserSharetribeToken, userIdFromAccessToken } from './sharetribeToken';

const LAST_USER_KEY = 'sl-last-user-id';
const sent = {};

const safeStorage = () => {
  try {
    return typeof window !== 'undefined' ? window.localStorage : null;
  } catch (e) {
    return null;
  }
};

export const rememberSignedInUser = userId => {
  const s = safeStorage();
  try {
    if (s && userId) s.setItem(LAST_USER_KEY, String(userId));
  } catch (e) {
    // ignore
  }
};

export const forgetSignedInUser = () => {
  const s = safeStorage();
  try {
    if (s) s.removeItem(LAST_USER_KEY);
  } catch (e) {
    // ignore
  }
};

export const lastSignedInUser = () => {
  const s = safeStorage();
  try {
    return (s && s.getItem(LAST_USER_KEY)) || null;
  } catch (e) {
    return null;
  }
};

export const sendAuthDiag = (event, extra = {}) => {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') return;
  if (sent[event]) return; // once per page load per event
  sent[event] = true;
  let tokenUser = null;
  let hasToken = false;
  try {
    const t = readBrowserSharetribeToken();
    hasToken = !!t;
    tokenUser = userIdFromAccessToken(t);
  } catch (e) {
    // ignore
  }
  const body = JSON.stringify({
    event,
    userId: extra.userId || tokenUser || lastSignedInUser(),
    status: extra.status != null ? extra.status : null,
    reason: extra.reason ? String(extra.reason).slice(0, 120) : null,
    hasToken,
    path: window.location ? window.location.pathname : null,
  });
  try {
    if (navigator.sendBeacon) {
      navigator.sendBeacon('/api/auth-diag', new Blob([body], { type: 'text/plain' }));
      return;
    }
  } catch (e) {
    // fall through
  }
  try {
    fetch('/api/auth-diag', { method: 'POST', body, keepalive: true, credentials: 'omit' }).catch(
      () => {}
    );
  } catch (e) {
    // ignore
  }
};
